import DeleteIcon from "src/assets/all-icons/delete-icon.jsx";

import EditArtworkIcon from '@/assets/all-icons/edit-artwork-icon';
import Text from '@/shared-components/text/components/Text';

import './styles/AddressCard.css';

export default function AddressCard({ addressData, setAddressToEdit, setAddressToRemove }) {
  return (
    <>
      <div className="address-item__container">
        <DeleteIcon className="address-item__remove-address" onClick={()=>setAddressToRemove(addressData)}/>

        <div className="address-item__address-info-container">
          <div className="address-item__address-info-text-container">
            <Text className="address-item__address-info-text text-margin" paragraph medium>
              {addressData.address_name} {addressData.address_surname}
            </Text>

            <Text className="address-item__address-info-text text-margin" paragraph medium>
              {addressData.address_address}
            </Text>

            <Text className="address-item__address-info-text text-margin" paragraph medium>
              {addressData.address_city}, {addressData.address_zip_code}
            </Text>

            <Text className="address-item__address-info-text text-margin" paragraph medium>
              {addressData.address_region}, {addressData.address_country}
            </Text>

            <Text className="address-item__address-info-text text-margin" paragraph medium>
              {addressData.address_phone.address_phone_prefix} {addressData.address_phone.address_phone_number}
            </Text>
          </div>

          <EditArtworkIcon className="address-item__address-info-edit-button" onClick={()=>setAddressToEdit(addressData)}/>
        </div>
      </div>
    </>
  );
}
